// extracted by mini-css-extract-plugin
export default {"root":"Button_root__j5CKF","default":"Button_default__1Xe2V","dark":"Button_dark__Igq1v"};